import { createContext } from 'react'
interface CableInterface {
  cable?: ActionCable.Cable
}

const ActionCableContext = createContext<CableInterface>({})

export default ActionCableContext
